import { LinkProperty } from "../ah.mb.model-utils";
import { INodeObject, NodeObject } from "../common/ah.mb.common.node-object";

/**
* Data for clipboard when copying nodes
*/
export class NodeCopyPasteData {
    sourceModelId: string;
    isCut: boolean;
    nodeFullPaths: Array<string>;

    /**
     * Ctor
     * @param sourceModelId
     * @param isCut
     * @param nodeFullPaths
     */
    constructor(sourceModelId: string, isCut: boolean, nodeFullPaths: Array<string>) {
        this.sourceModelId = sourceModelId;
        this.isCut = isCut;
        this.nodeFullPaths = nodeFullPaths;
    }
}

/**
 * Node diagram position
*/
export interface INodeDiagramPosition {
    nodePathAndName: string;
    xPos: number;
    yPos: number;
}

export interface ICoordinate {
    x, y: number;
}

export interface IKinkPoint {
    parentPathAndName: string;
    sourceNodePathAndName: string;
    destNodePathAndName: string;
    point: ICoordinate;
}

/**
 * Model observer interface
 * TODO move this into seperate discrete interfaces (ILinkCreatedObserver, INodeCreatedObserver)
 * or into a generic ("on", "linkcreated()") etc handler
*/
export interface IModelObserver {

    /**
     * Notification that a node has been created
     * @param sender 
     * @param node 
     * @param initData 
     * @returns {} 
     */
    nodeCreated(sender: Object, node: NodeObject, initData: Object);

    /**
     * Notification that a node has been renamed
     * @param sender 
     * @param pathAndName 
     * @param newName 
     * @returns {} 
     */
    nodeRenamed(sender: Object, pathAndName: string, newName: string);

    /**
     * Notification of node(s) deletion
     * @param sender 
     * @param nodes 
     * @returns {} 
     */
    nodesDeleted(sender: Object, nodes: Array<NodeObject>);

    /**
     * Nodes pasted notification
     * @param sender 
     * @param targetPath 
     * @param nodePathAndNames 
     * @param isCut 
     * @returns {} 
     */
    nodesPasted(sender: Object, targetPath: string, nodePathAndNames: Array<string>, isCut: boolean);

    /**
     * Link created notification
     * @param sourceNode 
     * @param destNode 
     * @param commodity 
     * @param units 
     * @param properties 
     * @returns {} 
     */
    linkCreated(sourceNode: string, destNode: string, commodity: string, units: string,
        properties: LinkProperty[]);

    /**
     * Link deleted notification
     * @param sourceNode 
     * @param destNode 
     * @returns {} 
     */
    linkDeleted(sourceNode: string, destNode: string);

    /**
* Notify observers of link creation
* @param srcNode
* @param destNode
* @param commodity
* @param units
* @param properties
*/
    linkEdited(srcNode: string,
        destNode: string,
        commodity: string,
        units: string,
        properties: Array<LinkProperty>);

    nodesGrouped(sender: Object, nodes: INodeObject[], groupName: string);
    nodesUngrouped(sender: Object, groupNodePathAndName: string): Promise<any>;

}



// WEBPACK FOOTER //
// ./ClientApp/scripts/model-notifier/ah.mb.ui.model-observer.ts